class HeaderCheckoutController {
    constructor(breakpointsService, shopPageStateService, trolleyService, settings, shopperService) {
        this.breakpointsService = breakpointsService;
        this.shopPageStateService = shopPageStateService;
        this.trolleyService = trolleyService;
        this.settings = settings;
        this.shopperService = shopperService;
    }

    $onInit() {
        this.isGuest = this.shopperService.IsGuest;
    }

    back() {
        window.history.back();
    }

    toggleCartOpen() {
        this.shopPageStateService.isCartOpen = !this.shopPageStateService.isCartOpen;
    }

    displayCartMobileIcon() {
        return !!(document.getElementById('header-closeButton'));
    }

    displayCart() {
        return ((!this.breakpointsService.isInDropDownMenuFormat && this.shopperService.IsGuest) ||
        (!this.shopperService.IsGuest && !this.breakpointsService.isInCartIconFormat));
    }

}

const headerCheckoutComponentDefinition = {
    controller: ['BreakpointsService', 'ShopPageStateService', 'TrolleyService', 'Settings', 'ShopperService', HeaderCheckoutController],
    template: require('./header-checkout.component.html').trim(),
};

module.exports = {
    HeaderCheckoutController,
    headerCheckoutComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/header/header-checkout.component.js